<script setup lang="ts">
import { onMounted } from 'vue'
import AppNavBar from '@/components/navigation/AppNavBar.vue'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

onMounted(() => {
  window.scrollTo(0, 0)
})
</script>

<template>
  <div class="flex-1 w-full">
    <AppNavBar />
    <router-view />
  </div>
</template>
